export default {
  title: "Unsaved Changes",
  content:
    "There are unsaved changes on this page. If you continue, the data will not be saved. Are you sure you would like to continue?",
}
